import type { AgentAttributionTransactionMeta } from '@atlaskit/editor-common/transaction-agent-attribution';
import { fetchRovoChatAgentIdentityAccountId } from '@atlassian/conversation-assistant-chat-prompt-input/utils/fetch-rovo-chat-agent-identity';
import { normalizeAccountIdFromIdentityAri } from '@atlassian/conversation-assistant-utils/default-agent';
import { mapToAssistanceServiceProduct } from '@atlassian/editor-ai-common/api/assistance-service';

import type { EditorPluginAIProvider } from '../../types/types';
import type { CONFIG_ITEM_KEYS } from '../../ui/prebuilt/config-items/config-item-keys';
import { isQuickActionAgentAttributionEnabled } from './quickActionAgentAttributionGate';
import { isQuickActionConfigItem } from './resolveAgentAttribution';

const QUICK_ACTION_CONVO_AI_AGENT_ATTRIBUTION: AgentAttributionTransactionMeta = {
	agentType: 'convo-ai',
};

export const shouldResolveQuickActionAgentAttribution = (
	configItemKey?: CONFIG_ITEM_KEYS,
): boolean => {
	if (!isQuickActionConfigItem(configItemKey)) {
		return false;
	}

	return isQuickActionAgentAttributionEnabled();
};

export const resolveQuickActionAgentAttribution = async ({
	editorPluginAIProvider,
}: {
	editorPluginAIProvider: EditorPluginAIProvider;
}): Promise<AgentAttributionTransactionMeta> => {
	if (!editorPluginAIProvider.isRovoEnabled) {
		return QUICK_ACTION_CONVO_AI_AGENT_ATTRIBUTION;
	}

	const cloudId = editorPluginAIProvider.getChannelVariables?.('rovo-agent')?.cloudId;
	if (!cloudId) {
		return QUICK_ACTION_CONVO_AI_AGENT_ATTRIBUTION;
	}

	try {
		const identityAccountId = await fetchRovoChatAgentIdentityAccountId({
			cloudId,
			product: mapToAssistanceServiceProduct(editorPluginAIProvider.product),
		});
		const agentId = normalizeAccountIdFromIdentityAri(identityAccountId);

		return {
			...QUICK_ACTION_CONVO_AI_AGENT_ATTRIBUTION,
			...(agentId ? { agentId } : {}),
		};
	} catch {
		return QUICK_ACTION_CONVO_AI_AGENT_ATTRIBUTION;
	}
};
